<script>
    import Button from '../button/Button.svelte';
    import Icon from '../icon/Icon.svelte'
    import Spinner from '../spinner/Spinner.svelte';

    export function hide() {
        reset()
    }

    export function showLoading() {
        reset()
        showSpinner = true
    }

    export function showError(options) {
        reset()
        message = options.message
        buttonOptions = options.buttonOptions
    }

    let showSpinner, message, buttonOptions
    reset()

    function reset() {
        showSpinner = false
        message = ''
        buttonOptions = undefined
    }
</script>

{#if showSpinner || message || buttonOptions}
    <div class="page no-print">
        {#if showSpinner}
            <div class="spinner">
                <Spinner></Spinner>
            </div>
        {/if}

        {#if message}
            <div class="message">
                <Icon name="dead"></Icon>
                {message}
            </div>
        {/if}

        {#if buttonOptions}
            <Button {...buttonOptions}></Button>
        {/if}
    </div>
{/if}

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.page {
  z-index: 9100;
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: hsl(27, 15%, 93%);
}

.message {
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 0 16px 24px 16px;
  text-align: center;
}
.message :global(svg) {
  width: 64px;
  fill: #9a9bb5;
}

.spinner {
  animation: intro 1s ease;
  color: rgba(18, 45, 64, 0.8);
}
@keyframes intro {
  0% {
    opacity: 0;
  }
  70% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}</style>
